module.exports = __webpack_public_path__ + "static/media/swimming.03bde192.mp4";